<template>
    <div>
        <div class="head-bar">
            <div>
                <el-input v-model="datas.add.controller" placeholder="controller" clearable></el-input>
                <el-input v-model="datas.add.action" placeholder="action" clearable></el-input>
                <el-button type="primary" @click="_load()">搜索</el-button>
            </div>
        </div>
        <el-table v-loading="datas.status == -1" :data="datas.data" stripe border @sort-change="_sort"
            @selection-change="_select">
            <template v-for="(item, index) in mix_fields">
                <el-table-column :prop="item.COLUMN_NAME" :label="item.COLUMN_COMMENT"
                    :width="item.width ? item.width : 'auto'" :key="index" sortable="custom">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row[item.COLUMN_NAME] }}
                        </div>
                    </template>
                </el-table-column>
            </template>
            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="controller" label="控制器"></el-table-column>
            <el-table-column prop="action" label="操作"></el-table-column>
            <el-table-column prop="params" label="参数"></el-table-column>
            <el-table-column prop="title" label="备注"></el-table-column>
            <el-table-column prop="is_login" label="登录" sortable="custom">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_login" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_login', scope.row.is_login)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="appends" sortable="custom">
                <template slot-scope="scope">
                    {{ scope.row.appends }}
                    <a @click="_quick_edit(table, scope.row.id, 'appends', '[]')">删除</a>
                </template>
            </el-table-column>
            <el-table-column prop="is_no" label="禁止访问" sortable="custom">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_no" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_no', scope.row.is_no)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="is_rule" label="验证" sortable="custom">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_rule" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_rule', scope.row.is_rule)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="is_request" label="过滤参数" sortable="custom">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_request" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_request', scope.row.is_request)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="is_filter_append" label="过滤append" sortable="custom">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_filter_append" :active-value="1" :inactive-value="0"
                        @change="_quick_edit(table, scope.row.id, 'is_filter_append', scope.row.is_filter_append)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="update_time" label="更新" sortable="custom">
                <template slot-scope="scope">
                    {{ _time_format(scope.row.update_time) }}
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建" sortable="custom">
                <template slot-scope="scope">
                    {{ _time_format(scope.row.update_time) }}
                </template>
            </el-table-column>
            <el-table-column width="150" label="操作">
                <template slot-scope="scope">
                    <div class="handle-box">
                        <el-button type="text" @click="_save(scope.row.id)">编辑</el-button>
                        <el-button type="text" @click="_del(scope.row.id)" class="c-danger">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-box">
            <el-pagination @size-change="_size" @current-change="_page" :current-page="datas.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="datas.limit" layout="total, sizes, prev, pager, next"
                :total="datas.total"></el-pagination>
        </div>
        <el-dialog :visible.sync="show_save">
            <el-form>
                <el-form-item label="名称">
                    <el-input v-model="r.title"></el-input>
                </el-form-item>
                <el-form-item label="父">
                    <el-input v-model="r.pid"></el-input></el-form-item>
                <el-form-item label="是否需要登录"><el-input v-model="r.is_login"></el-input></el-form-item>
                <el-form-item label="控制器"><el-input v-model="r.controller"></el-input></el-form-item>
                <el-form-item label="操作"><el-input v-model="r.action"></el-input></el-form-item>
                <el-form-item label="参数">
                    <div class="flex rules" style="flex-wrap: wrap;">
                        <div class="ml-5" v-for="(item, index) in r.params" :key="index"
                            @click="r.params.splice(index, 1)">
                            {{ item }}
                        </div>
                    </div>
                    <input type="text" v-model="add">
                    <el-button type="primary" @click="r.params.push(add)">新增</el-button>
                </el-form-item>
                <el-form-item label="append">
                    <el-button type="primary" @click="r.appends.push('')">新增</el-button>
                    <div class="flex rules" style="flex-wrap: wrap;">
                        <div v-for="(item, index) in r.appends" :key="index">
                            {{ item }}
                            <a @click="(r.appends || []).splice(index, 1)">删</a>
                            <!-- {{ item }} -->
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="是否验证">
                    <el-input v-model="r.is_rule"></el-input>
                </el-form-item>
                <el-form-item label="禁止访问"><el-input v-model="r.is_no"></el-input></el-form-item>
                <el-form-item label="是否过滤参数"><el-input v-model="r.is_request"></el-input></el-form-item>
                <el-form-item label=" ">
                    <el-button @click="_submit" type="primary">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <ls-table-data :table="table" @fields="(e) => {
                    mix_fields = e;
                }
                    "></ls-table-data>
    </div>
</template>
<script>
export default {
    data() {
        return {
            table: 'user_rule',
            datas: {
                order: {
                    update_time: 'desc',
                    is_login: 'asc'
                }
            },
            r: {
                appends: []
            },
            add: ''
        };
    },
    created() {
        this._load();
    },
    methods: {}
};
</script>
<style lang="scss">
@import 'index.scss';
</style>